import { render } from "./ServicesPerUserModal.vue?vue&type=template&id=f44fb9a4"
import script from "./ServicesPerUserModal.vue?vue&type=script&lang=js"
export * from "./ServicesPerUserModal.vue?vue&type=script&lang=js"

import "./ServicesPerUserModal.vue?vue&type=style&index=0&id=f44fb9a4&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__